import * as React from "react";
import "./index.scss";
import { NavLink } from "react-router-dom";
import { Button } from "react-bootstrap";


export default class SideBar extends React.Component {

    render(){
        return (
            <div className="side-bar d-none d-sm-block">
                <div className="inner">
                    <NavLink to={`/projects`}>
                        <Button variant="link" className="mb-2 d-flex align-items-center flex-column">
                            <i className="fas fa-chart-area" />
                            <span>Projects</span>
                        </Button>
                    </NavLink>
                    <NavLink to={`/contractors`}>
                        <Button variant="link" className="mb-2 d-flex align-items-center flex-column">
                            <i className="fas fa-layer-group" />
                            <span>Contractors</span>
                        </Button>
                    </NavLink>
                    <NavLink to={`/equipment`}>
                        <Button variant="link" className="mb-2 d-flex align-items-center flex-column">
                            <img src={require("../../assets/equipment.svg")} />
                            <span>Equipment</span>
                        </Button>
                    </NavLink>
                    <NavLink to={`/people`}>
                        <Button variant="link" className="mb-2 d-flex align-items-center flex-column">
                            <img src={require("../../assets/workers.svg")} />
                            <span>People</span>
                        </Button>
                    </NavLink>
                    <NavLink to={`/reports`}>
                        <Button variant="link" className="mb-2 d-flex align-items-center flex-column">
                            <img src={require("../../assets/reports.svg")} />
                            <span>Reports</span>
                        </Button>
                    </NavLink>
                    <NavLink to={`/alerts`}>
                        <Button variant="link" className="mb-2 d-flex align-items-center flex-column">
                            <img src={require("../../assets/alerts.svg")} />
                            <span>Alerts</span>
                        </Button>
                    </NavLink>
                    <NavLink to={`/settings`}>
                        <Button variant="link" className="mb-2 d-flex align-items-center flex-column">
                            <img src={require("../../assets/settings.svg")} />
                            <span>Settings</span>
                        </Button>
                    </NavLink>
                </div>
            </div>
        )
    }
}